import format from 'date-fns/format';

/**
 * @typedef {ReturnType<typeof import('lib_ui-primitives').themeValues>} Theme
 */

/**
 * @param {Object} columnHNode
 * @param {Theme} theme
 * @param {number} contentLength
 * @returns {number}
 */
export default function getHNodeValueWidth(columnHNode, theme, contentLength) {
    const { fontSize, columnWidthToHeightRatio, maxTableCharLength } = theme;
    let contentWidth = 0;
    switch (columnHNode.dataType) {
        case 'button':
            contentWidth = theme.button.minWidth;
            break;
        case 'link':
        case 'text':
            contentWidth = fontSize * contentLength || maxTableCharLength;
            break;
        case 'dateTime':
            switch (columnHNode.format) {
                case 'ISO': //2019-09-18T19:00:52-04:00
                    contentWidth = 28 * fontSize;
                    break;
                case 'P': // 04/29/1453
                    contentWidth = 10 * fontSize;
                    break;
                case 'PP p': // Apr 29, 1453 12:00 AM
                    contentWidth = 21 * fontSize;
                    break;
                case 'Pp': // 04/29/1453, 12:00 AM
                    contentWidth = 20 * fontSize;
                    break;
                default:
                    return format(new Date(), columnHNode.format).length * fontSize;
            }
            break;
        case 'localShortDate':
            contentWidth = 10 * fontSize;
            break;
        case 'localVerboseDateTime':
            contentWidth = 21 * fontSize;
            break;
        case 'encodedText':
            contentWidth = fontSize * contentLength || maxTableCharLength;
            break;
        case 'mappedBoolean':
            if (columnHNode.mappedTrueValue || columnHNode.mappedFalseValue) {
                contentWidth =
                    Math.max(columnHNode.mappedTrueValue.length, columnHNode.mappedFalseValue.length, 2.1) *
                    fontSize *
                    columnWidthToHeightRatio;
            } else {
                contentWidth = 5 * fontSize; //false
            }
            break;
        case 'gpsCoordinates':
            contentWidth = theme.icon.size + 2 * theme.textPadding;
            break;
        case 'nestedDetail':
            contentWidth = fontSize * contentLength || maxTableCharLength;
            break;
        case 'patchDetail':
            if (columnHNode.asCardBody) {
                return '100%';
            } else {
                // 4 columns, the first one 160px, the rest 200px each
                return 780;
            }
        case 'currency':
            contentWidth = 10 * fontSize;
            break;
        case 'fraction':
            // Sized from the text, with a floor. A fraction is short ("3 / 3") while its header
            // rarely is ("Verified"), so sizing from the content alone gives a column narrower
            // than its own title. The case must exist at all because the default below THROWS
            // for an unknown data type, and every grid computes a width even when the metadata
            // supplies one — a Fraction column without it takes the grid down before a cell is
            // ever rendered.
            contentWidth = Math.max(fontSize * contentLength, 9 * fontSize) || maxTableCharLength;
            break;
        default:
            throw new Error(`Unknown data type for column ${columnHNode.label}`);
    }
    return contentWidth;
}
